import { FC, useState } from "react";
import { Form, Input, Modal, notification } from "antd";
import { App } from "@/types/app"
import useAppAdd from "../hook/useAppAdd"
import PublicUpload from "@/styles/Upload"
import { useTranslation } from 'react-i18next';

interface IAddApp {
  open: boolean;
  onOk: (app: App) => void;
  onCancel: () => void;
}

interface AppAdd {
  desc: string;
  fileId?: string;
}

export const AddApp:FC<IAddApp> = ({ open, onOk, onCancel }) => {
  const { t } = useTranslation();
  const [inForm] = Form.useForm();

  const [addLoading, {addApp}] = useAppAdd()

  const [desc, setDesc] = useState<string>("")
  const [fileId, setFileId] = useState<string>("")

  const onFinish = () => {
    if(!desc || !fileId){
      notification.warning({ placement: 'top',message: t('app.plFillInfo')})
      return
    }
    inForm.validateFields()
      .then(() => {
        addApp({ desc, fileId }).then((appInfo:App) => {
          onOk(appInfo)
          resetFormValue()
        })
      }).catch((err) => notification.error({ placement: 'top',message: err}))
  }

  const handleCancel = () => {
    onCancel()
    resetFormValue()
  }

  const resetFormValue = () => {
    setTimeout(() => {
      inForm.resetFields()
      setDesc('')
      setFileId('')
    }, 500);
  }
  
  return (
    <Modal
      title={t('app.addAppRecord')}
      open={open}
      confirmLoading={addLoading}
      onOk={() => onFinish()}
      onCancel={handleCancel}
      destroyOnClose
      maskClosable={false}
      width={700}
    >
      <Form form={inForm} name="app" autoComplete="off"  labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
        <Form.Item<AppAdd>  label={t('app.updateDesc')}  name="desc" required >
          <Input.TextArea autoSize={{ minRows: 4 }} value={desc} onChange={(e) => setDesc(e.target.value.trim())} />
        </Form.Item>
        <Form.Item<AppAdd> label={t('app.file')} required valuePropName="fileList">
          <PublicUpload fileId={fileId} onChange={setFileId} />
        </Form.Item>
      </Form>
    </Modal>
  )
}